import { FormatReference } from "../../format";
import { DocumentIdentifier } from "../../document";
import { Department } from "../../department";
import { Patient } from "../../patient";
import { User } from "../../user";
import { WorkflowStatus, ReceptionFlag, ReceptionInputSection } from "../items";
import { InOutKinds } from "../kinds";

// 依頼詳細インデックス
export class ReceptionDetailSummary {
  public id: number;
  public status: WorkflowStatus;
  public format: FormatReference;
  public patient: Patient;
  public department: Department;
  public receptionId: number;
  public receptionNumber: string;
  public receptionDate: Date;
  public createLimitDate: Date;
  public deliveryLimitDate: Date;
  public finishDate: Date;
  public deliveryKind: string;
  public managers: User[];
  public generalFlag1: ReceptionFlag;
  public isBacked: ReceptionFlag;
  public isTemporary: ReceptionFlag;
  public isNearlyExpired: ReceptionFlag;
  public isExpired: ReceptionFlag;
  public isPaper: ReceptionFlag;
  public isCopy: ReceptionFlag;
  public paperName: string;
  public paperCompanyName: string;
  public document: DocumentIdentifier;
  public deleted: boolean;

  public createDateTime: Date;
  public createUser: User;
  public inputSection: ReceptionInputSection;
  public updateDateTime: Date;
  public nextMessages: string[];
  public generalComments: string[];
  public receiptDate: Date;
  public inOutType: InOutKinds;

  clone(): ReceptionDetailSummary {
    const newObj = new ReceptionDetailSummary();

    newObj.id = this.id;
    newObj.status = this.status;
    newObj.format = this.format;
    newObj.patient = this.patient;
    newObj.department = this.department;
    newObj.receptionId = this.receptionId;
    newObj.receptionNumber = this.receptionNumber;
    newObj.receptionDate = this.receptionDate;
    newObj.createLimitDate = this.createLimitDate;
    newObj.deliveryLimitDate = this.deliveryLimitDate;
    newObj.deliveryKind = this.deliveryKind;
    newObj.finishDate = this.finishDate;
    newObj.generalFlag1 = this.generalFlag1;
    newObj.isBacked = this.isBacked;
    newObj.isTemporary = this.isTemporary;
    newObj.isNearlyExpired = this.isNearlyExpired;
    newObj.isExpired = this.isExpired;
    newObj.isPaper = this.isPaper;
    newObj.isCopy = this.isCopy;
    newObj.paperName = this.paperName;
    newObj.paperCompanyName = this.paperCompanyName;
    newObj.document = this.document;
    newObj.deleted = this.deleted;

    newObj.createDateTime = this.createDateTime;
    newObj.createUser = this.createUser;
    newObj.inputSection = this.inputSection;
    newObj.updateDateTime = this.updateDateTime;
    newObj.nextMessages = this.nextMessages;
    newObj.generalComments = this.generalComments;
    newObj.receiptDate = this.receiptDate;
    newObj.inOutType = this.inOutType;

    return newObj;
  }

}
